import { __decorate } from "tslib";
import { Component, Mixins } from 'vue-property-decorator';
import PageTitle from '@/components/v2/PageTitle.vue';
import DeliveryAreaManager from '@/components/v2/DeliveryAreaManager.vue';
import ActionButton from '@/components/action_button/Index.vue';
import ViewportSizeMixin from '@/helpers/mixins/ViewportSizeMixin';
import CleverTapEventsMixin from '@/helpers/vue_mixins/v3/CleverTapEventsMixin';
let DeliveryAreas = class DeliveryAreas extends Mixins(ViewportSizeMixin, CleverTapEventsMixin) {
    get headers() {
        return [
            {
                text: 'REGION',
                value: 'regionName',
                align: 'left',
                sortable: false,
            },
            {
                text: 'CITY',
                value: 'name',
                align: 'left',
                sortable: false,
            },
            {
                text: 'DELIVERY FEE',
                value: 'deliveryFee',
                align: 'left',
                sortable: false,
                isCurrency: true,
            },
            {
                text: '',
                value: '',
                align: '',
                sortable: false,
            },
        ];
    }
    startDeliveryAreaCreate() {
        this.deliveryAreaAction('START CREATE');
    }
    mounted() {
        this.viewDeliveryAreasPage();
    }
};
DeliveryAreas = __decorate([
    Component({
        components: {
            PageTitle,
            DeliveryAreaManager,
            ActionButton,
        },
    })
], DeliveryAreas);
export default DeliveryAreas;
